module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 208
// module chunks = 0 1